import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory } from 'react-router';
import { validateEmail } from '../utils/functions';
// import { reactLocalStorage } from 'reactjs-localstorage';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const AddCustomer = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const [startDate, setStartDate] = useState(new Date());

    const { state, setStoreData, setCustomersGlobal } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState()
    const [loading, setLoading] = useState(false)
    const [userData, setUserData] = useState({
        cust_fname: '',
        cust_lname: '',
        cust_dob: new Date(),
        cust_phone: '',
        cust_email: '',
        cust_address: '',
        cust_best_contact: '',
        h_phone: '',
        st_id: state.storeData.st_id
    })

    useEffect(() => {


        // console.log('asd')
        // getStoreDataFromLocal()
        //     .then(data => {
        //         console.log('data = = = ')
        //         console.log(data)
        //     })

    }, [])

    function addCust(event) {


        event.preventDefault();

        if (userData.cust_fname == '') {
            forceUpdate();
            alert('Please enter a first name')

            return
        }
        if (userData.cust_lname == '') {
            alert('Please enter a last name')
            return
        }
        if (userData.cust_dob == '') {
            alert('Please enter date of birth')
            return
        }
        if (userData.cust_phone == '' && userData.h_phone == '') {
            alert('Please enter at least one phone')
            return
        }

        if (!validateEmail(userData.cust_email)) {
            alert('Please enter a valid email')
            return
        }
        if (userData.cust_address == '') {
            alert('Please enter customer address')
            return
        }
        if (userData.cust_best_contact == '') {
            alert('Please select customer best contact')

            return
        }


        // console.warn(userData)
        setLoading(true)
        apiRequest(userData, 'addcust')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == 1) {
                    // alert('Customer Added')
                    if (data.customers) {
                        // da
                        setCustomersGlobal(data.customers)
                        // history.replace('/viewCustomers'
                        history.replace('/AddPresciption', data.data)
                    }

                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }

    // useEffect(()=>{
    //     setFocus({
    //         ...focus,
    //         cust_fname : true
    //     })
    //     alert('asd')
    //     forceUpdate()
    // },[focus])


    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Add Customer</h1>
                                            </div>
                                            <div className="row">
                                                <form
                                                    onSubmit={(event) => addCust(event)}
                                                // id="frm_customer"
                                                >

                                                    <div className="form-group row">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >First Name</div>
                                                            <input
                                                                type="text"
                                                                name="cust_fname"
                                                                id="cust_fname"
                                                                className="form-control form-control-user"
                                                                placeholder="First Name"
                                                                required
                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_fname: t.target.value
                                                                    })
                                                                }}

                                                            />
                                                            <br />
                                                        </div>
                                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >Last Name</div>
                                                            <input
                                                                type="text"
                                                                name="cust_lname"
                                                                required
                                                                id="cust_lname"
                                                                className="form-control form-control-user"
                                                                placeholder="Last Name"
                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_lname: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>
                                                        <div
                                                            className="col-sm-6 mb-3 mb-sm-0"
                                                        >
                                                            <div className="editDetails" >DOB</div>

                                                            <DatePicker
                                                                className="form-control form-control-user"

                                                                // calendarContainer={MyContainer}
                                                                // showTimeSelect={true}
                                                                // dateFormat="mm-dd-yyyy"

                                                                placeholderText="mm-dd-yyyy"
                                                                selected={selectedDate}
                                                                onChange={(date) => {
                                                                    console.log(date)
                                                                    setSelectedDate(date)
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_dob: date
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>
                                                        <div id="div_own_phone" className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >Email</div>
                                                            <input
                                                                type="text"
                                                                name="cust_email"
                                                                id="cust_email"
                                                                className="form-control form-control-user"
                                                                placeholder="Email"
                                                                required
                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_email: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>
                                                        <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >H-Phone</div>
                                                            <input
                                                                type="number"
                                                                name="H-Phone"
                                                                id="H-Phone"
                                                                className="form-control form-control-user"
                                                                placeholder="H-Phone"

                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        h_phone: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>
                                                        <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >C-Phone</div>
                                                            <input
                                                                type="text"
                                                                name="cust_phone"
                                                                id="cust_phone"
                                                                className="form-control form-control-user"
                                                                placeholder="C-Phone"

                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_phone: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>

                                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >Address</div>
                                                            <input
                                                                type="text"
                                                                name="cust_address"
                                                                id="cust_address"
                                                                className="form-control form-control-user"
                                                                placeholder="Address"
                                                                required
                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_address: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <br />
                                                        </div>
                                                        {/* <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <select
                                                            name="cust_status"
                                                            id="cust_status"
                                                            className="form-control form-control-user"
                                                            placeholder="Status"
                                                        >
                                                            <option value selected disabled>
                                                                Status
                                                            </option>
                                                            <option value={1}>Active</option>
                                                            <option value={0}>Inactive</option>
                                                        </select>
                                                        <br />
                                                    </div> */}
                                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                                            <div className="editDetails" >Best Contact</div>
                                                            <select
                                                                required
                                                                name="cust_best_contact"
                                                                id="cust_best_contact"
                                                                className="form-control form-control-user"
                                                                placeholder="Best Contact"
                                                                onChange={(t) => {
                                                                    setUserData({
                                                                        ...userData,
                                                                        cust_best_contact: t.target.value
                                                                    })
                                                                }}

                                                            >
                                                                <option value selected disabled>
                                                                    Best Contact
                                                                </option>
                                                                <option value="SMS">Phone</option>
                                                                <option value="SMS">SMS</option>
                                                                <option value="email">Email</option>
                                                            </select>
                                                            <br />
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="submit"
                                                        id="add_customer"
                                                        className="btn btn-primary btn-user btn-block rBBtn"
                                                        // onClick={() => addCust()}
                                                        style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                        value="Save"
                                                    />

                                                    {/* </input> */}
                                                </form>
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}
                            <a className="scroll-to-top rounded" href="#page-top">
                                <i className="fas fa-angle-up" />
                            </a>
                            {/* Logout Modal*/}
                            <div
                                className="modal fade"
                                id="logoutModal"
                                tabIndex={-1}
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Ready to Leave?
                                            </h5>
                                            <button
                                                className="close"
                                                type="button"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Select "Logout" below if you are ready to end your current session.
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                data-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <a className="btn btn-primary" href="logout.php">
                                                Logout
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddCustomer
